// frontend/src/lib/SanityClient.ts
import { createClient } from '@sanity/client'

export const sanityClient = createClient({
  projectId: 'ardgtshq', // from sanity.io/manage
  dataset: 'production',
  apiVersion: '2023-01-01',
  useCdn: true,
})

// Non-CDN client for queries that need fresh data (e.g., hero ordering)
export const sanityClientFresh = createClient({
  projectId: 'ardgtshq',
  dataset: 'production',
  apiVersion: '2023-01-01',
  useCdn: false, // Always get fresh data
})
